import supabase from "artifact/supabase";
import connected from "standard/connected";
import define from "standard/define";
import paint from "standard/paint";
import repaint from "standard/repaint";
import trait from "standard/trait";
import style from "./style";

@define("m-get-started")
class GetStarted extends HTMLElement {
  #user;

  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  @connected
  @paint
  [trait.template]() {
    return this.#user
      ? `
        <a class='${style.getStarted}' href='/${this.#user.id}/dashboard'}>Dashboard</a>
      `
      : `
        <a class='${style.getStarted}' href='/oauth/sign-in'}>Entrar</a>
      `;
  }

  @connected
  @repaint
  async [trait.getUser]() {
    const {
      data: { user },
    } = await supabase.auth.getUser();
    this.#user = user;
    return this;
  }
}

export default GetStarted;
